SmTextField = require './sm-text-field'

App.SmMaskedInputComponent = SmTextField.extend
  env:   Em.inject.service('environment')
  session: Em.inject.service()
  mask: null

  completeHandler: ->
    return if @get('isDestroyed')
    Em.run.next =>
      value = @$().val()
      @sendAction 'onComplete', value

  incompleteHandler: ->
    return if @get('isDestroyed')

    orgFeatures = @get('session.currentOrganization.features')
    return unless orgFeatures.do_not_validate_min_phone_mask_length 
    Em.run.next =>
      value = @$().val()
      @sendAction 'onComplete', value.replaceAll('_', '')

  installMaskHandler: (->
    mask = @get('mask')

    if mask
      @$().inputmask(mask, oncomplete: @completeHandler.bind(@), onincomplete: @incompleteHandler.bind(@))
  ).on('didInsertElement')